import { useSpring, useTransform } from "motion/react";
import { useEffect, useState } from "react";
import { Brand } from "./Brand";

interface SwipingBrandProps {
  height: number | string;
  color?: any;
  className?: string;
  /**
   * Whether the caret (LogoMark) should flash like a cursor.
   * Default: false
   */
  flashing?: boolean;
}

export function SwipingBrand({ height, color, className, flashing = false }: SwipingBrandProps) {
  const typeProgress = useSpring(0, { stiffness: 40, damping: 18, mass: 0.7 });
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    typeProgress.set(1);
  }, [typeProgress]);

  useEffect(() => {
    const unsubscribe = typeProgress.on("change", (v) => {
      if (v >= 0.99) setIsFinished(true);
      else setIsFinished(false);
    });
    return unsubscribe;
  }, [typeProgress]);

  const clip = useTransform(typeProgress, (value: number) => `inset(0 ${Math.max(0, 100 - value * 100)}% 0 0)`);
  const caretLeft = useTransform(typeProgress, (value: number) => `${value * 110}%`);

  // Only flash if requested AND animation is finished
  const shouldFlash = flashing && isFinished;

  return (
    <Brand
      height={height}
      clipPath={clip}
      caretLeft={caretLeft}
      color={color}
      className={className}
      flashing={shouldFlash}
    />
  );
}
